import get from 'lodash/get';
import isNil from 'lodash/isNil';

export const LAST_SENDER_TYPES = {
  agents: 'Agent',
  bot: 'Bot',
  customers: 'Customer',
  system: 'System',
};

/**
 * Resolve the "Last Sender" label for a customer's latest message.
 *
 * The bot is an agent account, so its messages arrive with sender_type
 * 'agents'. Compare the sender id against the bot id first so bot messages
 * are labelled "Bot" instead of "Agent" (mirrors ConversationItem/TooltipContent).
 *
 * @param {Object} latestMessage - customer.latest_message
 * @param {number} botId - id of the bot agent
 * @param {Object} labels - sender_type -> label map; pass translated values
 *   (e.g. the customer label from translation.json) to override the defaults
 * @returns {string|null} label, or null when there is no sender type
 */
export function getLastSenderLabel(latestMessage, botId, labels = LAST_SENDER_TYPES) {
  const senderType = get(latestMessage, 'sender_type');
  if (!senderType) return null;

  const senderId = get(latestMessage, 'sender_id');
  if (!isNil(botId) && senderId === botId) {
    return labels.bot;
  }

  return labels[senderType] || senderType;
}
